module.exports = __webpack_public_path__ + "img/GD.c3644be1.png";